<script>
  import { onMount } from "svelte";
  import { result } from "../store.js";
  import datepicker from "js-datepicker";
  import "js-datepicker/dist/datepicker.min.css";

  export let item = {
    type: "date-range",
    min: 1,
    max: 100,
    required: false,
    title: "",
    description: "",
    placeholder: "",
  };
  export let index = 0;
  export let current = 0;
  let startDate = "";
  let endDate = "";

  onMount(() => {
    $result[index] = "";
    const startPicker = datepicker("#date-start", {
      id: 1,
      onSelect: (instance, date) => {
        // Do stuff when a date is selected (or unselected) on the calendar.
        // You have access to the datepicker instance for convenience.
        startDate = date.toDateString();
        if (startDate && endDate) $result[index] = startDate + " - " + endDate;
      },
      onShow: () => {
        if (index === current)
          document.getElementById("main").style.paddingBottom = "120px";
      },
      onHide: () => {
        if (index === current)
          document.getElementById("main").style.paddingBottom = "1rem";
      },
    });
    startPicker.calendarContainer.style.setProperty("width", "100%");

    const endPicker = datepicker("#date-end", {
      id: 1,
      onSelect: (instance, date) => {
        // Do stuff when a date is selected (or unselected) on the calendar.
        // You have access to the datepicker instance for convenience.
        endDate = date.toDateString();
        if (startDate && endDate) $result[index] = startDate + " - " + endDate;
      },
      onShow: () => {
        if (index === current)
          document.getElementById("main").style.paddingBottom = "120px";
      },
      onHide: () => {
        if (index === current)
          document.getElementById("main").style.paddingBottom = "1rem";
      },
    });
    endPicker.calendarContainer.style.setProperty("width", "100%");
  });
</script>

<input
  id="date-start"
  autocomplete="off"
  readonly
  required={item.required}
  placeholder="Start date"
/>
<input
  id="date-end"
  autocomplete="off"
  readonly
  required={item.required}
  placeholder="End date"
/>

<style>
  input {
    width: 100%;
  }
</style>
